import { FILE_STATES } from "@rpldy/shared";

const getUploadMetadata = sendOptions => {
  const keys = sendOptions.params && Object.keys(sendOptions.params);
  return keys !== null && keys !== void 0 && keys.length ? keys.map(name => `${name} ${btoa(sendOptions.params[name])}`).join(",") : undefined;
};

const addLocationToResponse = (request, location) => request.then(data => {
  if (data.state === FILE_STATES.FINISHED) {
    data.response.location = location;
  }

  return data;
});

export { getUploadMetadata, addLocationToResponse };